<template>
  <div class="main-container">
    <header class="main-header">
      <PageHeader />
    </header>

    <section class="banner-section">
      <PageMid />
    </section>

    <section class="content-section">
      <div class="left-column">
        <NoticeInfo />
      </div>
      <div class="middle-column">
        <WeatherInfo />
        <advertisement />
      </div>
      <div class="right-column">
        <ArticleRank />
      </div>
      
    </section>

    <FloatingPet />
    <div class="icp-content">
    <i class="fas fa-shield-alt"></i>
    <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer" aria-label="工信部备案信息">
      蜀ICP备2025129268号-1
    </a>
    <i class="fas fa-link"></i>
  </div>
  </div>
</template>

<script>
import PageHeader from "../components/PageHeader.vue";
import PageMid from "../components/PageMid.vue";
import WeatherInfo from "../components/WeatherInfo.vue";
import NoticeInfo from "../components/NoticeInfo.vue";
import PetCanvas from "@/components/PetCanvas.vue";
import FloatingPet from "@/components/FloatingPet.vue";
import ArticleRank from "@/components/ArticleRank.vue";
import Advertisement from "@/components/Advertisement.vue";

export default {
  name: "MainPage",
  components: {
    PageHeader,
    PageMid,
    WeatherInfo,
    NoticeInfo,
    PetCanvas,
    FloatingPet,
    ArticleRank,
    Advertisement,
  },
};
</script>

<style scoped>

.main-container {
  min-height: 100vh;
  background: linear-gradient(to bottom, #e8f4ff, #f5f7fa);
  display: flex;
  flex-direction: column;
}

.main-header {
  height: 80px;
  background-color: transparent;
  position: relative;
  z-index: 1000;
}

.banner-section {
  width: 100%;
  margin-bottom: 20px;
}

.content-section {
  display: grid;
  grid-template-columns: 1fr 1fr 1.2fr;
  gap: 20px;
  height: 680px;
  padding: 0 20px 30px;
  margin-top: 10px;
}

.left-column,
.middle-column,
.right-column {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.middle-column {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.icp-footer {
  background: rgba(0, 0, 0, 0.8);
  padding: 12px 0;
  color: #f0f0f0;
  font-size: 13px;
  position: relative;
  z-index: 1000;
}

.icp-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.icp-content a {
  color: black;
  text-decoration: none;
  transition: color 0.3s ease;
}

.icp-content a:hover {
  color: black;
  text-decoration: underline;
}

.fas {
  font-size: 14px;
  color: #fff;
}
</style>
